import { isPlatformBrowser } from '@angular/common';
import {  ChangeDetectorRef, Component,  Inject, Input, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { FerienFIlters } from '@app/models/filtermodels/FerienFIlters';
import { FerienFiltersService } from '@app/services/ferienhauser/ferieneFilters.service';
import { Subject, takeUntil } from 'rxjs';

interface Item {
    name: string;
    function: string;
    index?: number,
    field?: string;
}

@Component({
    selector: 'clever-ferienhauserselectedfilters',
    templateUrl: './ferienhauserselectedfilters.component.html',
    styleUrls: ['./ferienhauserselectedfilters.component.scss'],
    standalone: false
})
export class FerienhauserselectedfiltersComponent implements OnInit, OnDestroy {
    @Input() mode: string;
    @Input() isDisabled: boolean = false;
    protected unsubscribe$ = new Subject();
    isBrowser: boolean = false;
    list: Item[] = [];
    filter: FerienFIlters;

    constructor(
        @Inject(PLATFORM_ID) protected platformId: any,
        protected ferienFiltersService: FerienFiltersService,
        protected cdr: ChangeDetectorRef,
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
    }

    ngOnInit(): void {
        if (this.isBrowser) {
            this.initFilterSub();
        }
    }

    
    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    initFilterSub(): void {
        this.ferienFiltersService.getfilters$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((filter: FerienFIlters) => {
            if (filter) {
                this.checkFilters(filter);
            }
        });
    }

    checkFilters(filter): void {
        this.list = [];
        this.cdr.markForCheck();
        this.filter = JSON.parse(JSON.stringify(filter));

        this.checkTypes();
        this.checkAmenities();

        this.checkschlafzimmer();
        this.checkPrc();
        this.checkToSki();
        this.checkToCenter();
        this.checkToWater();
        this.checkRating();

        this.cdr.markForCheck();
        this.ferienFiltersService.setExtraCount(this.list.length);
    }

    async resetAll() {
        this.ferienFiltersService.resetFilters();
    }

    checkAmenities(): void {
        for (let i = 0; i < this.filter?.amenities?.length; i++) {
            this.list.push({
                name: this.filter.amenities[i].name,
                function: 'removeAmenities',
                index: i
            });
        }
    }

    async removeAmenities(index) {
        for (let i = 0; i < this.ferienFiltersService?.amenities?.length; i++) {
            if (this.ferienFiltersService.amenities[i].id === this.filter?.amenities[index].id) {
                this.ferienFiltersService.amenities[i].selected = false;
                i = this.ferienFiltersService.amenities.length;
            }
        }
        this.ferienFiltersService.amenitiesResult();
    }

    checkschlafzimmer(): void {
        if (this.filter?.bedrooms > 1) {
            this.list.push({
                name: this.filter?.bedrooms + ' Schlafzimmer',
                function: 'removeschlafzimmer',
            });
        }
    }

    async removeschlafzimmer() {
        this.ferienFiltersService.bedrooms = 1;
        this.ferienFiltersService.bedroomsresult();
    }

    checkTypes(): void {
        for (let i = 0; i < this.filter?.types?.length; i++) {
            this.list.push({
                name: this.filter.types[i].name,
                function: 'removeTypes',
                index: i
            });
        }
    }

    async removeTypes(index) {
        for (let i = 0; i < this.ferienFiltersService?.types?.length; i++) {
            if (this.ferienFiltersService.types[i].id === this.filter?.types[index].id) {
                this.ferienFiltersService.types[i].selected = false;
                i = this.ferienFiltersService.types.length;
            }
        }
        this.ferienFiltersService.typesResult();
    }

    checkToSki(): void {
        if (this.filter?.toSki > 0) {
            this.list.push({
                name: 'Max. ' + (this.filter?.toSki/1000) + 'km bis Skigebiet oder Skipiste',
                function: 'removeToSki',
            });
        }
    }

    async removeToSki() {
        this.ferienFiltersService.toSki = null;
        this.ferienFiltersService.toSkiResult();
    }

    checkToWater(): void {
        if (this.filter?.toWater > 0) {
            this.list.push({
                name: 'Max. ' + (this.filter?.toWater/1000) + 'km bis zum Wasser',
                function: 'removeToWater',
            });
        }
    }

    async removeToWater() {
        this.ferienFiltersService.toWater = null;
        this.ferienFiltersService.toWaterResult();
    }

    checkToCenter(): void {
        if (this.filter?.toCenter > 0) {
            this.list.push({
                name: 'Max. ' + (this.filter?.toCenter/1000) + 'km bis zum Stadtzentrum',
                function: 'removeToCenter',
            });
        }
    }

    async removeToCenter() {
        this.ferienFiltersService.toCenter = null;
        this.ferienFiltersService.toCenterResult();
    }

    checkRating(): void {
        if (this.filter?.rating?.length > 0) {
            this.list.push({
                name: this.filter?.rating === 'outstanding' ? '4,5+' : '4+',
                function: 'removeRating',
            });
        }
    }

    async removeRating() {
        this.ferienFiltersService.rating = null;
        this.ferienFiltersService.toRatingResult();
    }

    checkPrc(): void {
        if (this.filter?.minPrice > 9) {
            this.list.push({
                name: 'min ' + this.filter?.minPrice + '€',
                function: 'removeminprc',
            });
        }
        if (this.filter?.maxPrice < 1000) {
            this.list.push({
                name: 'max ' + this.filter?.maxPrice + '€',
                function: 'removemaxprc',
            });
        }
    }

    async removeminprc() {
        this.ferienFiltersService.minprcResult(9);
    }

    async removemaxprc() {
        this.ferienFiltersService.maxprcResult(1000);
    }
}
